import { render } from "./TinyPumperPendingIssues.vue?vue&type=template&id=a43b635e"
import script from "./TinyPumperPendingIssues.vue?vue&type=script&lang=js"
export * from "./TinyPumperPendingIssues.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__